var map = {
	"./amazon.svg": 81,
	"./dark/alfa.svg": 82,
	"./dark/amazon.svg": 83,
	"./dark/netflix.svg": 84,
	"./dark/playstation.svg": 85,
	"./dark/skype.svg": 86,
	"./light/alfa.svg": 87,
	"./light/amazon.svg": 88,
	"./light/netflix.svg": 89,
	"./light/playstation.svg": 90,
	"./light/skype.svg": 91,
	"./netflix.svg": 92,
	"./playstation.svg": 93,
	"./touch.svg": 94,
	"./viber.svg": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;